<template>
      <div class="policy-app-title">개인정보처리방침</div>
      <div class="policy-box app">
        <Privacy/>
      </div>

</template>

<script>
import Privacy from '@/components/terms/Privacy.vue';

export default {
  components:{
    Privacy,
  },
}
</script>